import React from "react";
import styled from "styled-components";
import Navbar from "../components/webpage/Navbar";
import Jumbotron from "../components/webpage/Jumbotron";
import TrustedBy from "../components/webpage/TrustedBy";
import VideoFrame from "../components/webpage/VideoFrame";
import PricingPlans from "../components/webpage/PricingPlans"; // Import the PricingPlans component
import Contact from "../components/webpage/Contact"; // Import the Contact component
import Footer from "../components/webpage/Footer";
import FAQ from "../components/webpage/faq";
import CookieConsent from "../components/webpage/CookieConsent";
import HowItWorks from "../components/webpage/HowItWorks";
import AnalyticsFeatures from "../components/webpage/AnalyticsFeatures";
import CounterpartyTrustSection from "../components/webpage/CounterpartyTrustSection";
import DashboardOverview from "../components/webpage/DashboardOverview";
import PromoBanner from "../components/webpage/PromoBanner";


const Home = () => {
  return (
    <HomeContainer>
      <Navbar />
{/*   <PromoBanner
    hideOnScroll
    hideAfterPx={60}
    showAgainAtTop
    dismissKey="promoBannerDismissed" 
  /> */}
      <Section style={{ paddingBottom: 0 }}>
        <Jumbotron />
      </Section>

          <Section style={{ paddingBottom: 0 }}>
        <DashboardOverview />
      </Section>



            <Section style={{ paddingBottom: 0 }}>
        <CounterpartyTrustSection />
      </Section>




  <Section style={{ paddingTop: 0, paddingBottom: 0 }}>
            <AnalyticsFeatures />

</Section>
      <Section style={{ paddingTop: 0, paddingBottom: 0 }}>
  <HowItWorks />

      </Section>
      <Section style={{ paddingTop: 0, paddingBottom: 0 }}>

        <VideoFrame />
      </Section>

  <Section style={{ paddingTop: 0, paddingBottom: 0 }}>
        <TrustedBy />
      </Section>
  <Section style={{ paddingTop: 0, paddingBottom: 0 }}>
        <PricingPlans />
      </Section>

  <Section style={{ paddingTop: 0, paddingBottom: 0 }}>
        <FAQ />
      </Section>

  <Section style={{ paddingTop: 0, paddingBottom: 0 }}>
        <Contact />
      </Section>

  <Section style={{ paddingTop: 0, paddingBottom: 0 }}>
        <Footer />
      </Section>
      <CookieConsent />
    </HomeContainer>
  );
};

const HomeContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background: white;
`;

const Section = styled.div`
  width: 100%;
  scroll-margin-top: 100px; /* Adjust for sticky navbars */
`;

export default Home;
